import { useEffect, useState, useMemo } from "react";
import { axiosIns } from "../../utils";
import { Container, Row } from "reactstrap";

// RangeSlider
import "nouislider/distribute/nouislider.css";

import DeleteModal from "../../Components/Common/DeleteModal";

import BreadCrumb from "../../Components/Common/BreadCrumb";
import TableContainer from "../../Components/Common/TableContainer";
// import { Rating, Published, Price } from "./EcommerceProductCol";
//Import data

//redux
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { isLegacyCrmEnabled } from "../../constants/featureFlags";

// import { red } from "@material-ui/core/colors";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";

const SingleOptions = [
  { value: "Watches", label: "Watches" },
  { value: "Headset", label: "Headset" },
  { value: "Sweatshirt", label: "Sweatshirt" },
  { value: "20% off", label: "20% off" },
  { value: "4 star", label: "4 star" },
];

const Stock = (props) => {
  // Definition des etats
  const [productList, setProductList] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  const [selectedMulti, setselectedMulti] = useState(null);
  const [product, setProduct] = useState(null);
  const [typeAbonnementCourant, setTypeAbonnementCourant] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate an asynchronous operation (e.g., fetching data)
    setTimeout(() => {
      setIsLoading(false); // Set loading to false once the data is fetched or loaded
    }, 2000); // Adjust the time according to your needs
  }, []);

  useEffect(() => {
    const fetchSubscription = async () => {
      try {
        const { data } = await axiosIns.get("/subscribes/");
        const lastIndex = data.length - 1;
        const currentType = data[lastIndex]?.pricing;
        setTypeAbonnementCourant(currentType);
      } catch (err) {
        console.error(err);
      }
    };

    fetchSubscription();
  }, []);

  useEffect(() => {
    if (!isLegacyCrmEnabled) return;
    const fetchStock = async () => {
      try {
        const { data } = await axiosIns.get("/stocks");
        setProductList(data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchStock();
  }, []);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      // filtering can be implemented here if needed using productList
    }
  };

  // const [cate, setCate] = useState(" ");

  // const categories = (category) => {
  //   let filteredProducts = products;
  //   if (category !== "all") {
  //     filteredProducts = products.filter((product) => product.category === category);
  //   }
  //   setProductList(filteredProducts);
  //   setCate(category);
  // };

  const [prod, setProd] = useState([]);
  const [prod1, setProd1] = useState([]);

  useEffect(() => {
    if (!isLegacyCrmEnabled) return;
    const fetchProd = async () => {
      try {
        const { data } = await axiosIns.get("/products");
        setProd(data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchProd();
  }, []);

  const ProductName = (j) => {
    for (let i = 0; i <= prod.length; i++) {
      if (j === prod[i]?.id) {
        return prod[i]?.designationProd;
      }
    }
  };

  const onClickDelete = (product) => {
    setProduct(product);
    setDeleteModal(true);
  };

  const handleDeleteProduct = () => {
    if (product) {
      setDeleteModal(false);
    }
  };

  const [dele, setDele] = useState(0);

  // Displat Delete Button
  const displayDelete = () => {
    const ele = document.querySelectorAll(".productCheckBox:checked");
    const del = document.getElementById("selection-element");
    setDele(ele.length);
    if (ele.length === 0) {
      del.style.display = "none";
    } else {
      del.style.display = "block";
    }
  };

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".productCheckBox:checked");
    const del = document.getElementById("selection-element");
    ele.forEach((element) => {
      del.style.display = "none";
    });
  };

  const columns = useMemo(
    () => [
      // {
      //   Header: " ",
      //   Cell: (cell) => {
      //     return <input type="checkbox" className="productCheckBox" value={cell.row.original.id} onClick={() => displayDelete()} />;
      //   },
      // },
      {
        Header: props.t("Produit"),
        accessor: "product",
        Cell: (product) => (
          <>
            <div className="d-flex align-items-center text-center">
              <div className="flex-grow-1">
                <h5 className="fs-14 mb-1">
                  <Link
                    to={`/ecommerce-product-details/${product.row.original.id}/`}
                    className="text-dark"
                  >
                    {" "}
                    {ProductName(product.row.original.product)}
                  </Link>
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("Date"),
        Cell: (product) => (
          <>
            <div className="d-flex align-items-center text-center">
              <div className="flex-grow-1">
                <h5 className="fs-14 mb-1 text-muted">
                  {product.row.original.date_mvnt}
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("Entrées"),
        Cell: (product) => (
          <>
            <div className="d-flex align-items-center text-center">
              <div className="flex-grow-1">
                <p className="fs-14 mb-1">
                  <Link
                    to={`/ecommerce-product-details/${product.row.original.id}/`}
                    className="text-dark"
                  >
                    {" "}
                    {product.row.original.qte_entre}
                    <i
                      className="ri-arrow-down-fill"
                      style={{ color: "#6bff6b" }}
                    ></i>
                  </Link>
                </p>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("Sorties"),
        Cell: (product) => (
          <>
            <div className="d-flex align-items-center text-center">
              <div className="flex-grow-1">
                <p className="fs-14 mb-1">
                  <Link
                    to={`/ecommerce-product-details/${product.row.original.id}/`}
                    className="text-dark"
                  >
                    {" "}
                    {product.row.original.qte_sortie}
                    <i
                      className="ri-arrow-up-fill"
                      style={{ color: "#fc4444" }}
                    ></i>
                  </Link>
                </p>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("Stock Dispo"),
        Cell: (product) => (
          <>
            <div className="d-flex align-items-center text-center">
              <div className="flex-grow-1">
                <p className="fs-14 mb-1">
                  {" "}
                  <span style={{ color: "#447bfc" }}>
                    {product.row.original.stock_dispo}
                  </span>{" "}
                </p>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("Stock Sécurité"),
        Cell: (product) => (
          <>
            <div className="d-flex align-items-center text-center">
              <div className="flex-grow-1">
                <p className="fs-14 mb-1">
                  {" "}
                  <span style={{ color: "#44fcb0" }}>
                    {product.row.original.stock_securite === null
                      ? 0
                      : product.row.original.stock_securite}
                  </span>
                </p>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("Stock Alerte"),
        Cell: (product) => (
          <>
            <div className="d-flex align-items-center text-center">
              <div className="flex-grow-1">
                <p className="fs-14 mb-1">
                  {" "}
                  <span style={{ color: "#fc4444" }}>
                    {product.row.original.stock_alerte === null
                      ? 0
                      : product.row.original.stock_alerte}
                  </span>
                </p>
              </div>
            </div>
          </>
        ),
      },
    ],
    [props],
  );

  document.title = props.t("Gestion des stocks | Le Conseiller du BTP");

  return (
    <div className="page-content">
      <ToastContainer closeButton={false} />

      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteProduct}
        onCloseClick={() => setDeleteModal(false)}
      />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb
          title={props.t("Stocks")}
          pageTitle={props.t("Gestion des stocks")}
        />

        <Row>
          <div className="col-xl-12 col-lg-12">
            <div>
              <div className="card">
                <div className="card-body pt-0">
                  {isLoading ? ( // If loading, show loading indicator
                    <div className="py-4 text-center">
                      <div>
                        <lord-icon
                          src="https://cdn.lordicon.com/xjovhxra.json"
                          trigger="loop"
                          colors="primary:#0960b6,secondary:#02376b"
                          style={{ width: "72px", height: "72px" }}
                        ></lord-icon>
                      </div>
                      <div className="mt-4">
                        <h5>{props.t("Chargement")}...</h5>
                      </div>
                    </div>
                  ) : !isLegacyCrmEnabled ? (
                    <div className="mt-4">
                      <h5>
                        {props.t(
                          "Le module stock n'est pas encore disponible sur le nouveau backend",
                        )}
                      </h5>
                    </div>
                  ) : typeAbonnementCourant === 1 ||
                    typeAbonnementCourant === 2 ||
                    typeAbonnementCourant === 3 ? (
                    <div className="mt-4">
                      <h5>
                        {props.t(
                          "Ce module n'est pas disponible sur votre formule",
                        )}
                      </h5>
                    </div>
                  ) : productList ? (
                    <TableContainer
                      columns={columns}
                      data={productList || []}
                      isAddUserList={false}
                      customPageSize={10}
                      divClass="table-responsive mb-1"
                      tableClass="mb-0 align-middle table table-striped table-hover"
                      theadClass="table-secondary text-muted text-center"
                      // isProductsFilter={true}
                    />
                  ) : (
                    <div className="py-4 text-center">
                      <div>
                        <lord-icon
                          src="https://cdn.lordicon.com/msoeawqm.json"
                          trigger="loop"
                          colors="primary:#405189,secondary:#0ab39c"
                          style={{ width: "72px", height: "72px" }}
                        ></lord-icon>
                      </div>

                      <div className="mt-4">
                        <h5>{props.t("Désolé, pas de resultats trouvés")}</h5>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Row>
      </Container>
    </div>
  );
};
Stock.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(Stock));
